<template>
    <div class="search-container">
        <search-input icon-class-name="icon-doc"
                      :placeholder="translate('offer_id')"
                      specific-class-name="findById"
                      :is-modal-visible=true>
        </search-input>
        <search-b-a-f-a icon-class-name="icon-loop"
                        :placeholder="translate('bafa_erp_number')"
                        specific-class-name="findByTypeNumber"
                        :is-modal-visible=true>
        </search-b-a-f-a>
        <universal-modal v-show="isModalVisible"
                         :modal-header="modalHeader"
                         :modal-content="modalContent"
                         :modal-button-title="modalButtonTitle"
                         :view="modalView"
                         @close="closeModal">
        </universal-modal>
    </div>
</template>

<script>
    import SearchInput from '@/components/bottom/SearchInput.vue';
    import UniversalModal from "./UniversalModal";
    import SearchBAFA from "./SearchBAF";

    export default {
        name: "Search",
        components: {
            SearchBAFA,
            UniversalModal,
            SearchInput,
        },
        data() {
            return {
                isModalVisible: false,
                isActive: false,
                modalHeader: '',
                modalContent: '',
                modalView: '',
                modalButtonTitle: ''
            }
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            closeModal() {
                this.isModalVisible = false;
            },

        },
        created() {
            this.$on('showModal', (param) => {
                this.modalHeader = param.modalHeader;
                this.modalContent = param.modalContent;
                this.modalView = param.modalView;
                this.modalButtonTitle = param.modalButtonTitle;
                this.isModalVisible = true;
            });
        },
        beforeDestroy() {
            this.$off('showModal');
        }
    }

</script>